export type TopNavKey =
  | 'home'
  | 'running'
  | 'swimming'
  | 'cycling'
  | 'hyrox'
  | 'triathlon'
  | 'dashboard';

export type TopNavItem = {
  key: TopNavKey;
  label: string;
  href?: string;
};

export const TOP_NAV_ITEMS: TopNavItem[] = [
  { key: 'home', label: 'Home', href: '/' },
  { key: 'running', label: 'Running', href: '/running' },
  { key: 'swimming', label: 'Swimming', href: '/swimming' },
  { key: 'cycling', label: 'Cycling', href: '/cycling' },
  { key: 'hyrox', label: 'Hyrox', href: '/hyrox' },
  { key: 'triathlon', label: 'Triathlon', href: '/triathlon' },
];
